/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class UserDescribeResponse {
    getFixupPrototypeFunction() { return UserDescribeResponse.fixupPrototype; }

    static newInstance(model: Partial<UserDescribeResponse>): UserDescribeResponse {
        let obj = Object.assign(new UserDescribeResponse(), model);
        UserDescribeResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<UserDescribeResponse>): UserDescribeResponse {
        if (!model) return null;
        return UserDescribeResponse.newInstance(<UserDescribeResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: UserDescribeResponse) {
        if (!obj) return;

        models.UserDescribeResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: UserDescribeResponse): boolean {
        Object.setPrototypeOf(obj, UserDescribeResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.groups) {
            for (let val of this.groups) {
                models.UserGroupMembership.fixupPrototype(val);
            }
        }
        if (this.role_assignment) {
            for (let val of this.role_assignment) {
                models.RoleAssignment.fixupPrototype(val);
            }
        }
    }

    /**
     * ID of the User. This is an auto generated and unique in the CoreStack system
     */
    user_id: string;

    /**
     * Username is unique in the CoreStack system. User can use this to login to CoreStack portal in addition to email
     */
    username: string;

    /**
     * Current Status of the user - active or inactive. Inactive user cannot login or use AccessKeys.
     */
    status: string;

    /**
     * Email of the User. This is unique in the CoreStack system.
     */
    email: string;

    /**
     * First Name of the user. It can be only alphanumeric.
     */
    first_name: string;

    /**
     * Last Name of the user. It can be only alphanumeric.
     */
    last_name: string;

    /**
     * User groups the user belongs to
     */
    groups: Array<models.UserGroupMembership>;

    /**
     * List of roles assignments for the user. The same user can be assigned different roles in different tenants
     */
    role_assignment: Array<models.RoleAssignment>;

    /**
     * ID of the Timezone such as Asia/Kolkata, Asia/Dubai and so on
     */
    timezone_id: string;

    /**
     * Name of the user/admin who created this user
     */
    created_by: string;

    /**
     * DateTime when the user was created
     */
    created_at: string;

    /**
     * Name of the user/admin last updated this user
     */
    updated_by: string;

    /**
     * DateTime when the user was last updated
     */
    updated_at: string;

    /**
     * User's Single Sign-on Id, if CoreStack is deployed using SingleSignOn (SSO) model
     */
    sso_userid: string;

    /**
     * ID of the Account in CoreStack. It will be available in the authToken API response
     */
    account_id: string;

    /**
     * Is Access Key available for this user.
     */
    is_accesskey_available: boolean;

    /**
     * source user id
     */
    source_user_id: string;

    /**
     * Access key of the user
     */
    access_key: string;

    /**
     * Time till which the user access key  is valid
     */
    valid_till: string;

    /**
     * Time when the user was last logged in
     */
    last_login_time: string;

    /**
     * Preferred language of the user
     */
    preferred_language: string;

}
